import {AppLanguageCode} from '../shared/i18n/app-language';

export const WHATS_NEW_SEO: Record<AppLanguageCode, {title: string; description: string}> = {
  "en": {
    "title": "What's new — Invemory",
    "description": "Discover the latest improvements and fixes in Invemory."
  },
  "uk": {
    "title": "Що нового — Invemory",
    "description": "Останні покращення та виправлення в Invemory."
  },
  "de": {
    "title": "Was ist neu — Invemory",
    "description": "Die neuesten Verbesserungen und Fehlerbehebungen in Invemory."
  },
  "ru": {
    "title": "Что нового — Invemory",
    "description": "Последние улучшения и исправления в Invemory."
  }
};
